import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import TitleCard from 'components/TitleCard';
import { DefaultFormFieldLayout } from 'components/FormField';
import FormStack from 'components/FormStack';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// TODO: implement actual page in #17088
function SessionAttendeesPage(_ref) {
  var isNested = _ref.isNested,
    sessionId = _ref.sessionId,
    session = _ref.session;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Stack, {
    spacing: "m",
    children: /*#__PURE__*/_jsx(TitleCard, {
      title: t('Session attendees'),
      variant: "raised",
      headingLevel: isNested ? 'h3' : 'h2',
      children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
        horizontal: true,
        children: /*#__PURE__*/_jsxs(FormStack, {
          spacing: "m",
          children: [sessionId, " ", session === null || session === void 0 ? void 0 : session.startDateTime]
        })
      })
    })
  });
}
export default SessionAttendeesPage;